import { api } from "../../axios";

export const actions = {

    // Cluster
    GetCluster(){
        return api.get(`Cluster/GetAll`);
    },
    GetSingleCluster(context, data){
        return api.get(`Cluster/${data}`);
    },
    UpdateCluster(context, data){
        return api.put(`Cluster/Update/${data.id}`, data);
    },
    DeleteCluster(context, data){
        return api.delete(`Cluster/Delete/${data}`);
    },
    CreateCluster(context, data){
        return api.post(`Cluster/Create`, data);
    },

}